import styled from "styled-components"
import {Tooltip} from "react-bootstrap"
import Info from "react-icons/lib/fa/info-circle"

import {WorkSansMedium} from "../../global/fonts"

export const StyledInfo = styled(Info)`
  float: right;
  color: ${({theme}) => theme.colors.greys.medium};
`

export const StyledTooltip = styled(Tooltip)`
  .tooltip-arrow {
    border-top-color: ${({theme}) => theme.colors.perkbox.greenBlue} !important;
    border-bottom-color: ${({theme}) => theme.colors.perkbox.greenBlue} !important;
  }
  .tooltip-inner {
    background-color: ${({theme}) => theme.colors.perkbox.greenBlue};
    padding: 20px;
    color: ${({theme}) => theme.colors.greys.white};
    ${WorkSansMedium}
  }
`
